module.exports = __webpack_public_path__ + "static/media/dice-d12.44c42aba.svg";